import React from "react";
import { FiLoader } from "react-icons/fi";
import { colorClasses, renderIcon } from "../utils";

export const EDAKpiCards = ({ cards, loading }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      {cards.map((card, i) => {
        const colors = colorClasses[card.color] || colorClasses.blue;
        return (
          <div key={i} className={`relative overflow-hidden rounded-xl border border-slate-200 bg-white p-4 shadow-sm border-l-4 ${colors.border}`}>
            <div className="flex items-center gap-2 mb-3">
              <div className={`flex h-5 w-5 items-center justify-center rounded ${colors.bg} text-white`}>
                {renderIcon(card.iconName)}
              </div>
              <h3 className="text-sm font-bold uppercase tracking-wide opacity-80 text-slate-500 truncate">
                {card.label}
              </h3>
            </div>
            <div className="text-3xl font-bold mt-1 text-slate-800 mb-1.5">
              {loading ? <FiLoader className="animate-spin h-5 w-5" /> : card.value}
            </div>
            <div className="text-xs text-slate-500 flex items-center gap-1.5">
              {card.trend && (
                <span className={`font-bold flex items-center gap-0.5 ${card.isPositive ? 'text-emerald-600' : 'text-red-500'}`}>
                  {card.isPositive ? '▲' : '▼'} {card.trend}
                </span>
              )}
              <span className="truncate">{card.subtitle}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
